import styled from 'styled-components';

const StyledBurger = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 2.4rem;
  width: 3rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 62;
  transition: opacity var(--dur-fast) var(--ease-standard);

  &:hover {
    opacity: 0.8;
  }

  div {
    width: 100%;
    height: 0.3rem;
    background: var(--ink);
    border-radius: var(--r-pill);
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :first-child {
      transform: ${({ open }) => (open ? 'rotate(45deg)' : 'rotate(0)')};
    }

    :nth-child(2) {
      opacity: ${({ open }) => (open ? '0' : '1')};
      transform: ${({ open }) => (open ? 'translateX(20px)' : 'translateX(0)')};
    }

    :nth-child(3) {
      transform: ${({ open }) => (open ? 'rotate(-45deg)' : 'rotate(0)')};
    }
  }
`;

const HiddenMenu = styled.nav`
  display: flex;
  flex-direction: column;
  background: var(--surface);
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
  min-height: 100vh;
  text-align: left;
  padding: 10rem 2.4rem 3rem;
  position: fixed;
  top: 0;
  right: 0;
  transition: transform var(--dur-base) var(--ease-standard);
  width: min(88vw, 38rem);
  z-index: 61;
  overflow-y: auto;
  box-shadow: var(--shadow-lg);
  border-left: 1px solid var(--border);

  a,
  button {
    font-size: 1.7rem;
    font-weight: 600;
    color: var(--ink);
    padding: 1.8rem 0;
    text-decoration: none;
    text-align: left;
    border-bottom: 1px solid var(--border);
    transition: color var(--dur-fast) var(--ease-standard);

    &:hover {
      color: var(--accent);
    }
  }

  h2 {
    margin-top: 4rem;
    margin-bottom: 0.5rem;
    font-size: 1.4rem;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: var(--ink-faint);
    font-weight: 600;
  }

  > button:last-child {
    margin-top: 3rem;
    border-bottom: none;
  }
`;

/* Ação do menu que não é navegação (sair, virar PRO, filtrar gratuitos). */
const MenuAction = styled.button`
  height: auto;
  border: none;
  background: transparent;
  width: 100%;
`;

export { MenuAction, StyledBurger, HiddenMenu };
